// The staging host and Cloudflare deploy previews (<branch>-racedaymap.<account>.workers.dev).
const NON_PRODUCTION_HOSTS = [".dev.racedaymap.com", ".workers.dev"];

export function sentryEnvironment(hostname: string): "staging" | "production" {
	return NON_PRODUCTION_HOSTS.some((suffix) => hostname.endsWith(suffix)) ? "staging" : "production";
}
